export default __webpack_public_path__ + "static/leos-8619f8d9e008401b1400b9c78a2afa08.jpg";